import { html, nothing } from "lit";
import { query, queryAll, state } from "lit/decorators.js";
import { ifDefined } from "lit-html/directives/if-defined.js";
import "../../atom/Icon/index.js";
import "../Link/index.js";
import "../Button/index.js";
import "../SearchInput/index.js";
import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { preventDefault } from "../../../decorators/preventDefault.js";
import { testingAttr } from "../../../directives/testingAttr.js";
import { TestingAttrs } from "./dropdownContent.selectors.js";
import { when } from "lit-html/directives/when.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfDropdownContent = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_show_close_button = false;
    this.dsf_show_search = false;
    this.dsf_searching = false;
    this.dsf_search_error = false;
    this.dsf_custom_content = false;
    this.hasHeaderContent = false;
    this._searchValue = "";
    this._showShadow = false;
  }
  handleSlotUpdate() {
    var _a, _b, _c, _d;
    const dropdownContentSlot = (_b = (_a = this._headerSlot) == null ? void 0 : _a.assignedElements) == null ? void 0 : _b.call(_a)[0];
    const baseSelectorSlot = (_c = dropdownContentSlot == null ? void 0 : dropdownContentSlot.assignedElements) == null ? void 0 : _c.call(dropdownContentSlot)[0];
    const filterSlot = (_d = baseSelectorSlot == null ? void 0 : baseSelectorSlot.assignedElements) == null ? void 0 : _d.call(baseSelectorSlot);
    this.hasHeaderContent = filterSlot ? filterSlot.length > 0 : false;
  }
  get showTitle() {
    return this.dsf_title_text || this.dsf_show_close_button;
  }
  get showFooter() {
    return this.dsf_clear_button_text || this.dsf_apply_button_text;
  }
  firstUpdated() {
    this._resizeObserver = new ResizeObserver(
      () => this._showShadow = this.scrollContainer.scrollHeight > this.scrollContainer.clientHeight
    );
    this._resizeObserver.observe(this.scrollContainer);
  }
  disconnectedCallback() {
    var _a;
    super.disconnectedCallback();
    (_a = this._resizeObserver) == null ? void 0 : _a.disconnect();
    this._resizeObserver = void 0;
  }
  get isContentFocused() {
    return this.contentElement === this.shadowRoot.activeElement;
  }
  focusInit() {
    setTimeout(() => this.focus(), 0);
  }
  resetScroll() {
    this.scrollContainer.scrollTop = 0;
  }
  clearSearch() {
    this.updateSearchValue("");
  }
  moveFocusToNextElement() {
    const focusableElements = [...this.focusableElements];
    if (!focusableElements.length) {
      return;
    }
    const activeElement = this.shadowRoot.activeElement;
    const activeElementIndex = focusableElements.indexOf(activeElement);
    let nextElementIndex = activeElementIndex + 1;
    if (nextElementIndex >= focusableElements.length) {
      nextElementIndex = 0;
    }
    focusableElements[nextElementIndex].focus();
  }
  handleCloseClick() {
    this.emit("close-click");
  }
  handleClearClick() {
    this.emit("clear-click");
  }
  handleApplyClick() {
    this.emit("apply-click");
  }
  handleSearchInput(event) {
    this.updateSearchValue(event.detail);
    this.emit({ name: "search", payload: this._searchValue });
  }
  updateSearchValue(value) {
    this._searchValue = value;
  }
  render() {
    const search = this.dsf_show_search ? html` <dsf-search-input
          id="search"
          dsf_placeholder=${ifDefined(this.dsf_search_placeholder)}
          class=${this.showTitle ? "mx-12 mb-8" : "mx-12 mb-8 mt-8"}
          .value=${this._searchValue}
          .dsf_loading=${this.dsf_searching}
          .dsf_message=${this.dsf_search_message}
          .dsf_error=${this.dsf_search_error}
          @input=${this.handleSearchInput}
          ${testingAttr(TestingAttrs.searchInput)}
        ></dsf-search-input>` : nothing;
    const title = this.showTitle ? html`<div class="dsf-text-s-medium flex flex-shrink-0 items-center p-12">
          ${this.dsf_title_text ? html`<span>${this.dsf_title_text}</span>` : nothing}
          ${this.dsf_show_close_button ? html`<dsf-icon
                dsf_name="X"
                class="ml-auto cursor-pointer"
                @click=${this.handleCloseClick}
              ></dsf-icon>` : nothing}
        </div>` : nothing;
    const header = this.showTitle || this.dsf_show_search ? html`<div class="flex flex-shrink-0 flex-col">${title} ${search}</div>` : nothing;
    const footer = this.showFooter ? html`<div class="flex flex-shrink-0 items-center gap-12 p-12">
          ${this.dsf_clear_button_text ? html`<dsf-link
                @click=${this.handleClearClick}
                ${testingAttr(TestingAttrs.clearButton)}
                >${this.dsf_clear_button_text}</dsf-link
              >` : nothing}
          ${this.dsf_apply_button_text ? html`<dsf-button
                dsf_size="small"
                @click=${this.handleApplyClick}
                class="ml-auto"
                ${testingAttr(TestingAttrs.applyButton)}
                >${this.dsf_apply_button_text}</dsf-button
              >` : nothing}
        </div>` : nothing;
    const contentTabIndex = !this.dsf_custom_content ? "0" : void 0;
    return html` <div class="dsf-text-s flex min-w-0 flex-auto flex-col font-sans">
      ${header}
      ${when(
      this.hasHeaderContent,
      () => html`<div class="p-12">
            <slot @slotchange=${this.handleSlotUpdate} name="header"></slot>
          </div>`,
      () => html`<slot @slotchange=${this.handleSlotUpdate} name="header"></slot>`
    )}
      <div
        id="content"
        class="relative flex flex-auto overflow-hidden rounded-xs focus:outline-none focus-visible:shadow-focus-secondary-md"
        tabindex=${ifDefined(contentTabIndex)}
      >
        <div id="scrollContainer" class="max-h-320 flex-auto overflow-y-auto" part="content">
          <slot></slot>
        </div>
        ${this._showShadow ? html`<div
              class="absolute -bottom-8 left-0 z-0 h-8 w-[100%] rounded-[50%] bg-neutral-100 shadow-dropdown"
            ></div>` : nothing}
      </div>
      ${footer}
    </div>`;
  }
};
__decorateClass([
  prop({ type: String })
], DsfDropdownContent.prototype, "dsf_title_text", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfDropdownContent.prototype, "dsf_show_close_button", 2);
__decorateClass([
  prop({ type: String })
], DsfDropdownContent.prototype, "dsf_clear_button_text", 2);
__decorateClass([
  prop({ type: String })
], DsfDropdownContent.prototype, "dsf_apply_button_text", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfDropdownContent.prototype, "dsf_show_search", 2);
__decorateClass([
  prop({ type: String })
], DsfDropdownContent.prototype, "dsf_search_placeholder", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfDropdownContent.prototype, "dsf_searching", 2);
__decorateClass([
  prop({ type: String })
], DsfDropdownContent.prototype, "dsf_search_message", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfDropdownContent.prototype, "dsf_search_error", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfDropdownContent.prototype, "dsf_custom_content", 2);
__decorateClass([
  query("#content")
], DsfDropdownContent.prototype, "contentElement", 2);
__decorateClass([
  query("#scrollContainer")
], DsfDropdownContent.prototype, "scrollContainer", 2);
__decorateClass([
  queryAll('dsf-input, dsf-search-input, dsf-button, dsf-link, [tabindex="0"]')
], DsfDropdownContent.prototype, "focusableElements", 2);
__decorateClass([
  query('slot[name="header"]')
], DsfDropdownContent.prototype, "_headerSlot", 2);
__decorateClass([
  state()
], DsfDropdownContent.prototype, "hasHeaderContent", 2);
__decorateClass([
  state()
], DsfDropdownContent.prototype, "_searchValue", 2);
__decorateClass([
  state()
], DsfDropdownContent.prototype, "_showShadow", 2);
__decorateClass([
  preventDefault
], DsfDropdownContent.prototype, "handleSearchInput", 1);
DsfDropdownContent = __decorateClass([
  defineElement("dsf-dropdown-content")
], DsfDropdownContent);
export {
  DsfDropdownContent
};
